<template>
  <div id="app" style="height: 100%">
    <transition name="fade">
    <div v-if="loading.loading" id="loading-wrapper">
      <div id="loading-text"><img width="90" src="img/icons/apple-icon.png"><br>lädt ...</div>
      <div id="loading-content"></div>
    </div>
    </transition>
    <base-alert v-if="alert.message" :type="alert.type" class="sticky">{{alert.message}}
    <button type="button" class="close" v-on:click.prevent="$store.dispatch('alert/clear')">
        <span aria-hidden="true">&times;</span>
      </button></base-alert>  <!--- data-dismiss="alert" aria-label="Close" --->
    <notifications></notifications>
    <router-view v-if="newT"/>
    <div v-else class="container">
      <card type="danger" gradient="secondary" shadow class="mt-5 text-center" shadow-size="25">
        <slot scope="header">
          <i class="mt-5 mb-5 fas fa-ban fa-10x text-danger"></i><i class="mt-5 mb-5 far fa-hand-paper fa-10x"></i>
          <h1 class="display-1">Achtung!</h1>
          <h1 class="display-4">Socialguard scheint bereits geöffnet zu sein oder wurde unsachgemäß beendet!</h1>
        </slot>
        <slot scope="body">
          <p class="lead mb-3">Bitte schließen Sie dieses Fenster und wechseln in das bereits geöffnete Fenster von Socialguard!</p>
          <base-button type="success" @click="pleaseFocus">Wo ist das Fenster?</base-button>
          <p class="lead mb-3">Falls kein Fenster geöffnet ist oder Socialguard unsachgemäß beendet wurde, können Sie die App hier neu laden:</p>
          <base-button type="secondary" @click.prevent="reset">neu laden</base-button>
        </slot>
    </card></div>
    <document-viewer></document-viewer>
    <ChangeOrganisation :show-modal="$store.getters['config/showCustomer']"></ChangeOrganisation>
    <ChangeLocation :show-modal="$store.getters['config/showLocation']"></ChangeLocation>
    <DemoToast v-if="isDemo()"></DemoToast>
      </div>
</template>

<script>
  //import Push from 'push.js';
  import DocumentViewer from "@/components/DocumentViewer/DocumentViewer";
  import ChangeOrganisation from "@/layout/ChangeOrganisation";
  import ChangeLocation from "@/layout/ChangeLocation";
  import DemoToast from "@/components/DemoToast.vue";
  //import posthog from 'posthog-js'
  export default {
    name: 'app',
    components:{DemoToast, ChangeLocation, ChangeOrganisation, DocumentViewer},
    data() {
      return {
        localStorageTimeout: 15 * 1000, // 15,000 milliseconds = 15 seconds.
        localStorageResetInterval: 10 * 1000, // 10,000 milliseconds = 10 seconds.
        localStorageTabKey: 'sg-browser-tab',
        sessionStorageGuidKey:'browser-tab-guid',
        newT: true,
        channel: new BroadcastChannel('tab'),
        tabMessage: '2nd-tab-opened',
        tabMessageAnswer: 'close-2nd-tab'
      }
    },
    created() {

      //this.pushNotiMsg("Hallo Nutzer");


      /* let's try without - starting at march 3rd.23
      //Beginn: Restrict multiple Tabs opened with support function to find old tab and initiate close
      this.newT = this.testTab();
      // main tab listener for support func
      this.channel.addEventListener('message', (msg) => {
        if (msg.data === this.tabMessage) {
          // message received from 2nd tab
          // focus main window and send message to close 2nd tab
          if(this.testTab()) {
            // eslint-disable-next-line no-console
            console.log("showDoubleScreenPush");
            this.channel.postMessage(this.tabMessageAnswer);
            Push.create("Hier klicken ...", {
              body: "... um bestehendes Fenster zu öffnen",
              icon: '/img/icons/apple-icon.png',
              timeout: 2400000,
              onClick: function () {
                window.focus();
                this.close();
              }
            });
          }
        }
      });

      // 2nd tab listener for support func
      this.channel.addEventListener('message', (msg) => {
        if (msg.data === this.tabMessageAnswer) {
          // message received from 2nd tab
          // focus main window and send message to close 2nd tab
          if(!this.testTab()) {
              window.removeEventListener('beforeunload', this.beforeunload);
              window.open('', '_self', '').close();
          }
        }
      });

      //end

      */


      // temp disable posthog - because of build error: https://github.com/PostHog/posthog-js/issues/1484
      /*
      posthog.init('phc_A7Oy08pbB3dhqJVauHKP4yU6MaLXcTZlF0diMA9kcgI', {
        api_host: 'https://eu.posthog.com',
        ui_host: 'eu.posthog.com',
        loaded: function (posthog) {
          posthog.identify(this.$store.getters['authentication/email'])
        }
      }); */


      if(this.$store.getters['authentication/isAuthenticated']) this.$store.dispatch('profiles/getProfiles');
      window.addEventListener('beforeunload', this.beforeunload)
    },
    beforeDestroy() {
      window.removeEventListener('beforeunload', this.beforeunload)
    },
    computed: {
      alert () {
        return this.$store.state.alert;
      },
      loading () {
        return this.$store.state.loading;
      }
    },
    watch:{
      // eslint-disable-next-line no-unused-vars
      $route (to, from){
        // clear alert on location change
        //this.$store.dispatch('alert/clear');
      }
    },
    methods: {
      beforeunload(e) {
        e.preventDefault();
        this.$store.dispatch('profiles/setNoActiveProfile');
        e.returnValue = "App verlassen?";
      },
      reset() {
        localStorage.removeItem(this.localStorageTabKey);
        localStorage.removeItem(this.sessionStorageGuidKey);
        this.$router.go(this.$router.currentRoute);
      },
      setTabObj(sessionGuid) {
        let newTabObj = {
          guid: sessionGuid,
          timestamp: new Date().getTime()
        };
        localStorage.setItem(this.localStorageTabKey, JSON.stringify(newTabObj));
      },
      createGUID() {
        let guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
          /*eslint-disable*/
          let r = Math.random() * 16 | 0,
                  v = c == 'x' ? r : (r & 0x3 | 0x8);
          /*eslint-enable*/
          return v.toString(16);
        });

        return guid;
      },
      testTab() {
        if (!navigator.userAgent.includes('SGScanner')) {
            let sessionGuid = sessionStorage.getItem(this.sessionStorageGuidKey) || this.createGUID();
            let tabObj = JSON.parse(localStorage.getItem(this.localStorageTabKey)) || null;
            sessionStorage.setItem(this.sessionStorageGuidKey, sessionGuid);
            // If no or stale tab object, our session is the winner.  If the guid matches, ours is still the winner
            if (tabObj === null || (tabObj.timestamp < new Date().getTime() - this.localStorageTimeout) || tabObj.guid === sessionGuid) {
              this.setTabObj(sessionGuid);
              this.$store.dispatch('tabwatchertimer/add',setInterval(() => {this.setTabObj(sessionGuid)}, this.localStorageResetInterval)) ;
              return true;
            } else {
              // An active tab is already open that does not match our session guid.
              return false;
            }
        } else {
            return true;
        }
      },
      pleaseFocus() {
        this.channel.postMessage(this.tabMessage);
      },
      isDemo() {
        return process.env.VUE_APP_DEMOUSER === this.$store.getters['authentication/email']
      },
    }
  };
</script>

<style>
  div.sticky {
    position: fixed;
    z-index: 10000;
    width: 99%;
    margin-top: 1rem;
    margin-left: 1rem;
    margin-right: 2rem;
  }
</style>